import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import '../node_modules/element-plus/theme-chalk/index.css'
//element-plus 的中文化
import locale from '../node_modules/element-plus/lib/locale/lang/zh-cn'  //element-plus

//判断是否移动端的函数
const isMobileFunc = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (flag === null) {
        return 0;
    } else {
        return 1;
    }
};

//设置html的字号大小，作为rem的计算依据
const setHtmlFontSize = () => {
    //let designWidth = 640;
    const htmlDom = document.getElementsByTagName('html')[0];
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    console.log('htmlWidth:'+htmlWidth);
    if (isMobileFunc() === 1) {
        console.log('is mobile');
        //移动端
        htmlDom.style.fontSize = `${htmlWidth / 6.4}px`;

    } else {
        //非移动端:
        //console.log('htmlWidth:'+htmlWidth);
        console.log('not is mobile');
        let dest = htmlWidth * 0.36;
        if (dest < 360) {
            dest = 360;
        }
        htmlDom.style.fontSize = `${dest / 6.4}px`;
    }
    console.log('fontSize:'+htmlDom.style.fontSize);
};

window.onresize = setHtmlFontSize;
setHtmlFontSize();
console.log(navigator.userAgent);
const app = createApp(App)
app.use(ElementPlus,{locale})
app.mount('#app')
